import Competitor from '../views/competitor/Index.vue';
import CompetitorAnalysis from '../views/competitor/Analysis.vue';
import { checkauth } from '../Helper';

const CompetitorSite = () => import('../views/competitor/SitePage.vue');
const CompetitorMatch = () => import('../views/competitor/MatchPage.vue');

const guardia = (to, from, next) => {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
};

export default [
	{
		path: '/competitor',
		name: 'competitor',
		component: Competitor,
		beforeEnter: guardia,
	},
	{
		path: '/competitor/analisi',
		name: 'competitor-analysis',
		component: CompetitorAnalysis,
		beforeEnter: guardia,
	},
	// sito concorrente e abbinamento: pagine, non piu' finestre della pagina Competitor
	{
		path: '/competitor/sites/new',
		name: 'competitor-site-new',
		component: CompetitorSite,
		beforeEnter: guardia,
	},
	{
		path: '/competitor/sites/:id([0-9a-fA-F]{24})',
		name: 'competitor-site',
		component: CompetitorSite,
		beforeEnter: guardia,
	},
	{
		path: '/competitor/products/:id([0-9a-fA-F]{24})/match',
		name: 'competitor-match',
		component: CompetitorMatch,
		beforeEnter: guardia,
	},
];
